<template>
  <vx-card title="Mis Proyectos" code-toggler>
    <div class="vx-row">
      <div class="vx-col md:w-5/5 w-full mt-5">
          <vs-table pagination max-items="15" stripe search :data="listaProyectos">
            <template slot="thead">
              <vs-th sort-key="nombreproyecto">Proyecto</vs-th>
              <vs-th sort-key="cliente">Cliente</vs-th>
              <vs-th sort-key="fecha_compra">Fecha</vs-th>
              <vs-th sort-key="puntos">VIVOCOINS</vs-th>
              <vs-th sort-key="id">Editar</vs-th>
              <vs-th sort-key="id">Ver Detalle</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
                <vs-td :data="data[index].proyecto">
                  {{ data[index].proyecto }}
                </vs-td>
                <vs-td :data="data[index].cliente">
                  {{ data[index].cliente }}
                </vs-td>
                
                <vs-td :data="data[index].fc">
                  {{ data[index].fc }}
                </vs-td>

                <vs-td :data="data[index].puntos">
                  {{ data[index].puntos }}
                </vs-td>

                <vs-td :data="data[index].id">
                  <router-link :to="{ name: 'proyectos', params: { id: data[index].id } }"><vs-icon>edit</vs-icon></router-link>
                </vs-td>
                
                <vs-td :data="data[index].id">
                  <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="Detalle(data[index].id )" />
                </vs-td>

              </vs-tr>
            </template>
          </vs-table>
        <div v-if="tablaProducto" id="scrolltabla">

          <vs-list>
            <vs-list-header :title="this.Proyecto['proyecto']"></vs-list-header>
            <vs-list-item title="Cliente" :subtitle="this.Proyecto['cliente']"></vs-list-item>
            <vs-list-item title="Email / Teléfono" :subtitle="this.Proyecto['email']+' / '+this.Proyecto['telefono']"></vs-list-item>
            <vs-list-item title="Contacto" :subtitle="this.Proyecto['contacto']"></vs-list-item>
            <vs-list-item title="Dirección" :subtitle="this.Proyecto['direccion']"></vs-list-item>
          </vs-list>

          <vs-table pagination max-items="20" stripe search :data="Productos">
            <template slot="header">
              <h4>
                <vs-icon icon="list"></vs-icon> Productos
              </h4>
            </template>
            <template slot="thead">
              <vs-th sort-key="n">Nº</vs-th>
              <vs-th sort-key="macaddress">No. Serie</vs-th>
              <vs-th sort-key="proveedor">Proveedor</vs-th>
              <vs-th sort-key="producto">Producto</vs-th>
              <vs-th sort-key="puntos">VIVOCOINS</vs-th>
              <vs-th sort-key="fecha">Garantia</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
                <vs-td :data="index+1">
                  {{ index+1 }}
                </vs-td>
                <vs-td :data="data[index].macaddress">
                  {{ data[index].macaddress }}
                </vs-td>
                <vs-td :data="data[index].proveedor">
                  {{ data[index].proveedor }}
                </vs-td>
                <vs-td :data="data[index].producto">
                  {{ data[index].producto }}
                </vs-td>
                <vs-td :data="data[index].puntos">
                  {{ data[index].puntos }}
                </vs-td>
                <vs-td :data="data[index].fecha_garantia">
                  {{ data[index].fecha_garantia }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </vx-card>  
</template>
<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'sweetalert2/dist/sweetalert2.min.css';
import Datepicker from 'vuejs-datepicker'
import axios from '../../axios.js'
import vSelect from 'vue-select'
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
Vue.component('v-select', vSelect)
import { Validator } from 'vee-validate'
export default {
  data () {
    return {
      listaProyectos: [],
      Productos: [],
      Proyecto: [],
      tablaProducto: false
    }
  },
  methods: {
    VerProyectos() {
      this.$vs.loading({type:'corners'});
      this.$http.post('Proyecto','obtenerProyectos',{},(data)=>{
          this.listaProyectos = data;
          this.$vs.loading.close();
      });
    },
    Detalle(id) {
      this.$vs.loading({type:'corners'});
      this.VerListaProductos(id);
    },
    VerListaProductos(id){
      this.tablaProducto = true;
      window.location.href='#scrolltabla';
      this.$http.post('Proyecto','obtenerProyectoProductos',{id},(data)=>{
        this.Productos = data[1];
        this.Proyecto = data[0];
        this.$vs.loading.close();
      });
    },
  },
  components: {
    Datepicker,
    FormWizard,
    TabContent
  }, 
  mounted() {
    this.VerProyectos();
  },
}
</script>